var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activities.selected)?_c('div',{staticClass:"select-calendar-view-type"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }